/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesIllustration,
  propTypesLink,
  propTypesTextHtml,
} from '../../../constants/Proptypes';

const propTypesSliceInteractiveVertical = {
  interactive_vertical_cta_datatrack_attribute: PropTypes.string,
  interactive_vertical_cta_label: PropTypes.string,
  interactive_vertical_cta_link: PropTypes.shape(propTypesLink),
};

const propTypesItemsInteractiveVertical = {
  interactive_vertical_cta_title: PropTypes.string,
  interactive_vertical_cta_illustration: PropTypes.shape(propTypesIllustration),
  description: PropTypes.shape(propTypesTextHtml),
};

export const propTypesDataInteractiveVertical = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceInteractiveVertical),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsInteractiveVertical)),
};
